@if (bormeData || detail) {
    @if (showBormeSection()) {
        <tec-collapse
            [icon]="'icon-capture-popup'"
            [title]="'OPERATIONS.DETAIL.BORME.SECTION_QUERY' | translate"
            [expanded]="expandedCollapseSection === 'borme'"
            (clickEvent)="toggleCollapse('borme', $event)"
        >
            <div class="grid grid-i3">
                <tec-info-group [label]="'OPERATIONS.DETAIL.BORME.TAX_ID' | translate">
                    <span>{{ bormeData?.tax_id || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'OPERATIONS.DETAIL.BORME.COMPANY_NAME' | translate">
                    <span>{{ bormeData?.company_name || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.TYPE' | translate">
                    <span>{{ bormeTypeLabel() }}</span>
                </tec-info-group>
                <tec-info-group [label]="'OPERATIONS.DETAIL.BORME.RESULT_SUMMARY' | translate">
                    <span>{{ bormeData?.result_summary || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'OPERATIONS.DETAIL.BORME.PUBLICATION_REF' | translate">
                    <span>{{ bormeData?.publication_reference || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                </tec-info-group>
            </div>
        </tec-collapse>
    }

    @if (showExtraSection()) {
        <tec-collapse
            [icon]="'icon-file'"
            [title]="'OPERATIONS.DETAIL.BORME.SECTION_EXTRA' | translate"
            [expanded]="expandedCollapseSection === 'extra'"
            (clickEvent)="toggleCollapse('extra', $event)"
        >
            <div class="grid grid-i3">
                @for (row of detailsEntries(); track row.key) {
                    <tec-info-group [label]="detailFieldDisplayLabel(row.key)">
                        <span>{{ formatDetailValue(row.value) }}</span>
                    </tec-info-group>
                }
            </div>
        </tec-collapse>
    }

    <tec-collapse
        [icon]="'icon-pending-check'"
        [title]="'OPERATIONS.DETAIL.TABS.DETAILS.OPERATION' | translate"
        [expanded]="expandedCollapseSection === 'operation'"
        (clickEvent)="toggleCollapse('operation', $event)"
    >
        <app-operation-detail-operation-meta
            [operationUuid]="detail?.uuid"
            [processUuid]="detail?.process_uuid"
            [startAt]="bormeData?.start_at || detail?.start_at"
            [endAt]="bormeData?.end_at || detail?.end_at"
            [totalTime]="bormeData?.total_time ?? detail?.total_time"
            triesStyle="badge"
            [triesLabel]="totalTriesLabel"
            [state]="bormeData?.state"
            [showKoOnTries]="true"
            [typeLabel]="'OPERATIONS.BORME' | translate"
            [obtainMethodLabel]="obtainMethodLabel | translate"
        />
    </tec-collapse>
} @else {
    <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.DETAILS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
}
